<template>
  <div class="home-page" @click="closeAllBox" @contextmenu="closeAllBox">
    <div class="app-container" :class="{ fullscreen: configStore.fullScreen }">
      <!-- 左侧侧边栏 -->
      <div class="navi-bar">
        <div class="brand-card">
          <el-image class="brand-mark" v-if="companyLogo" :src="companyLogo" lazy-load />
          <div class="brand-copy">
            <div class="brand-title">{{ companyName }}</div>
            <div class="brand-subtitle">智能客服管理</div>
          </div>
        </div>

        <nav class="sidebar-nav">
          <!-- 控制台 -->
          <router-link class="link" to="/home/console">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/console' }" type="button">
              <!-- 灰色 (默认显示) -->
              <img class="icon-gray" src="@/assets/image/console.png" />
              <!-- 蓝色 (激活显示) -->
              <img class="icon-blue" src="@/assets/image/console-1.png" />
              <span>控制台</span>
            </button>
          </router-link>

          <!-- 工作台 -->
          <router-link class="link" to="/home/chat">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/chat' }" type="button">
              <img class="icon-gray" src="@/assets/image/workbench.png" />
              <img class="icon-blue" src="@/assets/image/workbench-1.png" />
              <span>工作台</span>
            </button>
          </router-link>

          <!-- 历史记录 -->
          <router-link class="link" to="/home/chatHistory">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/chatHistory' }" type="button">
              <img class="icon-gray" src="@/assets/image/history.png" />
              <img class="icon-blue" src="@/assets/image/history-1.png" />
              <span>历史记录</span>
            </button>
          </router-link>

          <!-- 客户管理 -->
          <router-link class="link" to="/home/customers">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/customers' }" type="button">
              <img class="icon-gray" src="@/assets/image/client.png" />
              <img class="icon-blue" src="@/assets/image/client-1.png" />
              <span>客户管理</span>
            </button>
          </router-link>

          <!-- 网页端渠道配置 -->
          <router-link class="link" to="/home/channels">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/channels' }" type="button">
              <img class="icon-gray" src="@/assets/image/wang1.png" />
              <img class="icon-blue" src="@/assets/image/wang2.png" />
              <span>网页端渠道配置</span>
            </button>
          </router-link>

          <!-- 设置 -->
          <!-- <router-link class="link" to="/home/site">
            <button class="nav-button" :class="{ 'is-active': $route.path === '/home/site' }" type="button">
              <span class="icon iconfont icon-shezhi" style="font-size: 18px"></span> 
              <span>设置</span>
            </button>
          </router-link> -->
        </nav>

        <div v-if="!configStore.electronMode" class="bottom-item" @click="onSwtichFullScreen">
          <i class="el-icon-full-screen"></i>
        </div>
        <!-- <button class="logout-button" type="button" @click="onExit()">
          <img class="logout-img" src="../assets/image/exit.png" alt="退出" />
          <span>退出登录</span>
        </button> -->
        <div class="logout-button">
          <el-popover placement="top" width="80px" trigger="click" popper-class="download-popover">
            <div class="download-qrcode">
              <!-- <img class="qrcode-img" src="@/assets/image/qrcode.png" alt="二维码" /> -->
            </div>

            <el-button slot="reference" class="logout-btn-box appDown">
              <img class="logout-img" src="@/assets/image/phomn.png" alt="app" />
              移动端下载
            </el-button>
          </el-popover>

          <el-button class="logout-btn-box" @click="onExit()">
            <img class="logout-img" src="../assets/image/red-exit.png" alt="退出" />
            退出登录
          </el-button>
        </div>
      </div>
      <div class="content-box">
        <Header :mine="mine" @user-menu="handleUserMenu"></Header>
        <router-view></router-view>
      </div>
      <user-info ref="userInfo"></user-info>
      <group-info ref="groupInfo"></group-info>
      <full-image ref="fullImage"></full-image>
      <preview-file ref="previewFile"></preview-file>
      <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
      <rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
      <user-profile-card ref="userProfileCard"></user-profile-card>
      <setting-user-info ref="settingUserInfo"></setting-user-info>
      <account-info-dialog ref="accountInfoDialog" />
      <login-ip-whitelist-dialog ref="loginIpWhitelistDialog" :mine="mine" @confirm="onLoginIpWhitelistConfirm" />
      <network-diagnosis-dialog ref="networkDiagnosisDialog" />
      <logout-confirm-dialog ref="logoutConfirmDialog" @confirm="onLogoutConfirmDialog"
        @confirm-transfer="onLogoutConfirmTransfer" />
      <two-factor-login-dialog ref="twoFactorLoginDialog" @bind="onTwoFactorBind" />
    </div>
  </div>
</template>

<script>
import HeadImage from "../components/common/HeadImage.vue";
import UserInfo from "../components/common/UserInfo.vue";
import GroupInfo from "../components/group/GroupInfo.vue";
import FullImage from "../components/common/FullImage.vue";
import RtcPrivateVideo from "../components/rtc/RtcPrivateVideo.vue";
import RtcPrivateAcceptor from "../components/rtc/RtcPrivateAcceptor.vue";
import RtcGroupVideo from "../components/rtc/RtcGroupVideo.vue";
import UserProfileCard from "../components/common/UserProfileCard.vue";
import PreviewFile from "../components/common/PreviewFile.vue";
import SettingUserInfo from "../components/jkt/setting-userinfo.vue";
import AccountInfoDialog from "../components/setting-jkt/account-info-dialog.vue";
import LoginIpWhitelistDialog from "../components/setting-jkt/login-ip-whitelist-dialog.vue";
import NetworkDiagnosisDialog from "../components/setting-jkt/network-diagnosis-dialog.vue";
import LogoutConfirmDialog from "../components/setting-jkt/logout-confirm-dialog.vue";
import TwoFactorLoginDialog from "../components/setting-jkt/two-factor-login-dialog.vue";
import Header from "../layout/components/Header/index.vue";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../utils/contant/contant";

export default {
  components: {
    HeadImage,
    UserInfo,
    GroupInfo,
    FullImage,
    RtcPrivateVideo,
    RtcPrivateAcceptor,
    RtcGroupVideo,
    UserProfileCard,
    PreviewFile,
    SettingUserInfo,
    AccountInfoDialog,
    LoginIpWhitelistDialog,
    NetworkDiagnosisDialog,
    LogoutConfirmDialog,
    TwoFactorLoginDialog,
    Header
  },
  data() {
    return {
      audio: false,
      lastPlayAudioTime: new Date().getTime() - 1000,
      reconnecting: false,
      notification: null,
      privateMessagesBuffer: [],
      groupMessagesBuffer: [],
      systemMessagesBuffer: []
    };
  },
  methods: {
    init() {
      this.$eventBus.$on("exit", this.onExitFromBus);
      this.$eventBus.$on("openPrivateVideo", (rctInfo) => {
        // 进入单人视频通话
        this.$refs.rtcPrivateVideo.open(rctInfo);
      });
      this.$eventBus.$on("openGroupVideo", (rctInfo) => {
        // 进入多人视频通话
        this.$refs.rtcGroupVideo.open(rctInfo);
      });
      this.$eventBus.$on("openUserInfo", (user, pos) => {
        // 打开用户卡片
        this.$refs.userInfo.open(user, pos);
      });
      this.$eventBus.$on("openGroupInfo", (group, token, pos) => {
        // 打开群卡片
        this.$refs.groupInfo.open(group, token, pos);
      });
      this.$eventBus.$on("openFullImage", (url) => {
        // 图片大图
        this.$refs.fullImage.open(url);
      });
      this.$eventBus.$on("openPreviewFile", (url) => {
        // 文件预览
        this.$refs.previewFile.open(url);
      });
      this.$eventBus.$on("openSettingUserInfo", () => {
        // 个人资料 / 修改密码
        this.$refs.settingUserInfo.open();
      });
      // this.$eventBus.$on("openCopyUrl", (url) => {
      //   // 客服专属连接
      //   this.$refs.copyUrlDialog.open(url);
      // });
      this.configStore.setAppInit(false);
      this.loadStore()
        .then(() => {
          // ws初始化
          this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(ACCESS_TOKEN_KEY));
          this.$wsApi.onConnect(() => {
            if (this.reconnecting) {
              this.onReconnectWs();
            } else {
              // 加载离线消息
              this.pullOfflineMessage();
              this.configStore.setAppInit(true);
            }
          });
          this.$wsApi.onMessage((cmd, msgInfo) => {
            if (cmd == 2) {
              // 关闭ws
              this.$wsApi.close(3000);
              // 异地登录，强制下线
              this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.onExit();
                }
              });
            } else if (cmd == 3) {
              if (!this.configStore.appInit || this.chatStore.loading) {
                // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
                this.privateMessagesBuffer.push(msgInfo);
              } else {
                // 插入私聊消息
                this.handlePrivateMessage(msgInfo);
              }
            } else if (cmd == 4) {
              if (!this.configStore.appInit || this.chatStore.loading) {
                // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
                console.log("消息进入缓存区:", msgInfo);
                this.groupMessagesBuffer.push(msgInfo);
              } else {
                // 插入群聊消息
                this.handleGroupMessage(msgInfo);
              }
            } else if (cmd == 5) {
              if (!this.configStore.appInit || this.chatStore.loading) {
                // 如果正在拉取离线消息，先放进缓存区，等待消息拉取完成再处理，防止消息乱序
                this.systemMessagesBuffer.push(msgInfo);
              } else {
                // 处理系统消息
                this.handleSystemMessage(msgInfo);
              }
            }
          });
          this.$wsApi.onClose((e) => {
            console.log(e);
            if (e.code != 3000) {
              // 断线重连
              this.reconnectWs();
              this.configStore.setAppInit(false);
            }
          });
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("初始化失败");
          this.onExit();
        });
    },
    reconnectWs() {
      // 记录标志
      this.reconnecting = true;
      // 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
      this.userStore
        .loadUser()
        .then(() => {
          // 断线重连
          this.$message.error("连接断开，正在尝试重新连接...");
          this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(ACCESS_TOKEN_KEY));
        })
        .catch(() => {
          // 10s后重试
          setTimeout(() => this.reconnectWs(), 10000);
        });
    },
    onReconnectWs() {
      // 重连成功
      this.reconnecting = false;
      // 重新加载群和好友
      const promises = [];
      promises.push(this.friendStore.loadFriend());
      // promises.push(this.groupStore.loadGroup());
      Promise.all(promises)
        .then(() => {
          // 加载离线消息
          this.pullOfflineMessage();
          this.configStore.setAppInit(true);
          this.$message.success("重新连接成功");
        })
        .catch(() => {
          this.$message.error("初始化失败");
          this.onExit();
        });
    },
    loadStore() {
      return this.userStore.loadUser().then(() => {
        const promises = [];
        promises.push(this.friendStore.loadFriend());
        // promises.push(this.groupStore.loadGroup());
        promises.push(this.chatStore.loadChat());
        promises.push(this.pendingTransferStore.loadPendingAcceptList());
        promises.push(this.configStore.loadConfig());
        return Promise.all(promises);
      });
    },
    unloadStore() {
      this.friendStore.clear();
      this.groupStore.clear();
      this.chatStore.clear();
      this.pendingTransferStore.clear();
      this.userStore.clear();
    },
    pullOfflineMessage() {
      let timeStamp = new Date().getTime();
      this.chatStore.setLoading(true);
      const promises = [];
      promises.push(this.pullPrivateOfflineMessage(this.chatStore.privateMsgMaxId));
      // promises.push(this.pullGroupOfflineMessage(this.chatStore.groupMsgMaxId));
      // promises.push(this.pullSystemOfflineMessage(this.chatStore.systemMsgMaxSeqNo));
      Promise.all(promises)
        .then((messages) => {
          // 处理离线消息
          messages[0].forEach((m) => this.handlePrivateMessage(m));
          // messages[1].forEach((m) => this.handleGroupMessage(m));
          // messages[2].forEach((m) => this.handleSystemMessage(m));
          // 处理缓冲区收到的实时消息
          this.privateMessagesBuffer.forEach((m) => this.handlePrivateMessage(m));
          // this.groupMessagesBuffer.forEach((m) => this.handleGroupMessage(m));
          // this.systemMessagesBuffer.forEach((m) => this.handleSystemMessage(m));
          // 清空缓冲区
          this.privateMessagesBuffer = [];
          // this.groupMessagesBuffer = [];
          // this.systemMessagesBuffer = [];
          // 关闭加载离线标记
          this.chatStore.setLoading(false);
          // 刷新会话
          this.chatStore.refreshChats();
          // 打印耗时
          // let size = messages[0].length + messages[1].length + messages[2].length;
          let size = messages[0].length;
          let time = new Date().getTime() - timeStamp;
          console.log("加载离线消息耗时:", time, ",消息数量:", size);
        })
        .catch((e) => {
          console.log(e);
          this.$message.error("拉取离线消息失败");
          this.onExit();
        });
    },
    pullPrivateOfflineMessage(minId) {
      return this.$http({
        url: "/message/private/loadOfflineMessage?minId=" + minId,
        method: "GET"
      });
    },
    pullGroupOfflineMessage(minId) {
      return this.$http({
        url: "/message/group/loadOfflineMessage?minId=" + minId,
        method: "GET"
      });
    },
    pullSystemOfflineMessage(minSeqNo) {
      return this.$http({
        url: "/message/system/loadOfflineMessage?minSeqNo=" + minSeqNo,
        method: "GET"
      });
    },
    handlePrivateMessage(msg) {
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.mine.id;
      // 好友id
      let friendId = msg.selfSend ? msg.recvId : msg.sendId;
      // 会话信息
      let chatInfo = {
        type: "PRIVATE",
        targetId: friendId
      };
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.chatStore.resetUnreadCount(chatInfo);
        return;
      }
      // 消息回执处理,改消息状态为已读
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        this.chatStore.readedMessage({
          friendId: msg.sendId
        });
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.chatStore.recallMessage(msg, chatInfo);
        return;
      }
      // 好友申请
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPLY) {
        this.friendStore.addRequest(JSON.parse(msg.content));
        return;
      }
      // 好友申请被同意、拒绝、撤回
      if (
        msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_APPROVE ||
        msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_REJECT ||
        msg.type == this.$enums.MESSAGE_TYPE.FRIEND_REQ_RECALL
      ) {
        this.friendStore.removeRequest(JSON.parse(msg.content).id);
        return;
      }
      // 新增好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
        this.friendStore.addFriend(JSON.parse(msg.content));
        return;
      }
      // 删除好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
        this.friendStore.removeFriend(friendId);
        return;
      }
      // 好友在线状态
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_ONLINE) {
        this.friendStore.updateOnlineStatus(JSON.parse(msg.content));
        return;
      }
      // 对好友设置免打扰
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DND) {
        this.friendStore.setDnd(friendId, JSON.parse(msg.content));
        this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 对好友进行会话置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_TOP) {
        this.friendStore.setTop(friendId, JSON.parse(msg.content));
        this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 客服：待转接申请（content 为列表项 JSON，与 /customer/transfer/list 项结构一致）
      if (msg.type == this.$enums.MESSAGE_TYPE.TRANSFER_PENDING) {
        try {
          const data = typeof msg.content === "string" ? JSON.parse(msg.content) : msg.content;
          if (data && typeof data === "object") {
            this.pendingTransferStore.addPendingFromWebSocket(data);
          }
        } catch (e) {
          console.warn("TRANSFER_PENDING parse", e);
        }
        return;
      }
      // 单人webrtc 信令
      if (this.$msgType.isRtcPrivate(msg.type)) {
        this.$refs.rtcPrivateVideo.onRTCMessage(msg);
        return;
      }
      // 消息插入
      if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
        let friend = this.loadFriendInfo(friendId);
        this.insertPrivateMessage(friend, msg);
      }
    },
    insertPrivateMessage(friend, msg) {
      let chatInfo = {
        type: "PRIVATE",
        targetId: friend.id,
        showName: friend.showNickName,
        headImage: friend.headImage,
        companyName: friend.companyName,
        isDnd: friend.isDnd,
        isTop: friend.isTop
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
      if (
        !friend.isDnd &&
        !this.chatStore.loading &&
        !msg.selfSend &&
        this.$msgType.isNormal(msg.type) &&
        msg.status != this.$enums.MESSAGE_STATUS.READED
      ) {
        // 播放提示音
        this.playAudioTip();
        // 消息提醒
        let chat = this.chatStore.findChat(chatInfo);
        this.showNotification(chat, friend.showNickName, friend.headImage);
      }
    },
    handleGroupMessage(msg) {
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.mine.id;
      // 发送用户昵称优先显示好友备注的名字
      if (msg.sendId && msg.sendNickName) {
        let f = this.friendStore.findFriend(msg.sendId);
        if (f && !f.deleted && f.remarkNickName) {
          msg.sendNickName = f.remarkNickName;
        }
      }
      let chatInfo = {
        type: "GROUP",
        targetId: msg.groupId
      };
      // 消息已读处理
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        // 我已读对方的消息，清空已读数量
        this.chatStore.resetUnreadCount(chatInfo);
        this.chatStore.resetAtMessage(chatInfo);
        return;
      }
      // 消息回执处理
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        // 更新消息已读人数
        let msgInfo = {
          id: msg.id,
          groupId: msg.groupId,
          readedCount: msg.readedCount,
          receiptOk: msg.receiptOk
        };
        this.chatStore.updateMessage(msgInfo, chatInfo);
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.chatStore.recallMessage(msg, chatInfo);
        return;
      }
      // 新增群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
        this.groupStore.addGroup(JSON.parse(msg.content));
        return;
      }
      // 删除群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
        this.groupStore.removeGroup(msg.groupId);
        return;
      }
      // 群消息置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP_MESSAGE) {
        let topMessage = msg.content ? JSON.parse(msg.content) : null;
        this.groupStore.updateTopMessage(msg.groupId, topMessage);
        return;
      }
      // 对群设置免打扰
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DND) {
        this.groupStore.setDnd(msg.groupId, JSON.parse(msg.content));
        this.chatStore.setDnd(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 群全体禁言
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_ALL_MUTED) {
        this.groupStore.setAllMuted(msg.groupId, JSON.parse(msg.content));
        return;
      }
      // 被禁言
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_MEMBER_MUTED) {
        this.groupStore.setMuted(msg.groupId, JSON.parse(msg.content));
        return;
      }
      // 对好友进行会话置顶
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_TOP) {
        this.groupStore.setTop(msg.groupId, JSON.parse(msg.content));
        this.chatStore.setTop(chatInfo, JSON.parse(msg.content));
        return;
      }
      // 群通话信令
      if (this.$msgType.isRtcGroup(msg.type)) {
        if (msg.type == this.$enums.MESSAGE_TYPE.RTC_GROUP_INFO) {
          // 群通话状态变化
          const rtcInfo = JSON.parse(msg.content);
          this.groupStore.setRtcInfo(msg.groupId, rtcInfo);
        } else {
          this.$nextTick(() => {
            this.$refs.rtcGroupVideo.onRTCMessage(msg);
          });
        }
        return;
      }
      // 插入群聊消息
      if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
        let group = this.loadGroupInfo(msg.groupId);
        this.insertGroupMessage(group, msg);
      }
    },
    insertGroupMessage(group, msg) {
      let chatInfo = {
        type: "GROUP",
        targetId: group.id,
        showName: group.showGroupName,
        headImage: group.headImageThumb,
        isDnd: group.isDnd,
        isTop: group.isTop
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
      // 提示音和消息提醒
      if (
        !group.isDnd &&
        !msg.selfSend &&
        !this.chatStore.loading &&
        this.$msgType.isNormal(msg.type) &&
        msg.status != this.$enums.MESSAGE_STATUS.READED
      ) {
        // 播放提示音
        this.playAudioTip();
        // 消息提醒
        let chat = this.chatStore.findChat(chatInfo);
        this.showNotification(chat, group.showGroupName, group.headImageThumb);
      }
    },
    handleSystemMessage(msg) {
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.chatStore.resetUnreadCount({
          type: "SYSTEM",
          targetId: 0
        });
        return;
      }
      // 用户被封禁
      if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
        this.$wsApi.close(3000);
        this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.onExit();
          }
        });
        return;
      }
      // 用户账户注销
      if (msg.type == this.$enums.MESSAGE_TYPE.USER_UNREG) {
        this.$wsApi.close(3000);
        this.$alert("您的账号已注销", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.onExit();
          }
        });
        return;
      }
      // 插入消息
      this.insertSystemMessage(msg);
    },
    insertSystemMessage(msg) {
      let headImage = require("@/assets/image/chat_system.png");
      let chatInfo = {
        type: "SYSTEM",
        targetId: 0,
        showName: "系统通知",
        headImage: headImage
      };
      // 打开会话
      this.chatStore.openChat(chatInfo);
      // 插入消息
      this.chatStore.insertMessage(msg, chatInfo);
    },
    onSwtichFullScreen() {
      this.configStore.setFullScreen(!this.configStore.fullScreen);
    },
    onExitFromBus() {
      this.onExit();
    },
    onExit(logoutTerminal = false) {
      // 如果本地没有token，则直接退出登录
      if (!sessionStorage.getItem(ACCESS_TOKEN_KEY)) {
        this.unloadStore();
        this.configStore.setAppInit(false);
        this.$wsApi.close(3000);
        localStorage.setItem("isAutoLogin", false);
        this.$router.push("/login");
        return;
      }
      this.$http({
        url: "/logout?logoutTerminal=" + logoutTerminal,
        method: "post",
        data: { logoutTerminal }
      })
        .then((data) => {
          this.unloadStore();
          this.configStore.setAppInit(false);
          this.$wsApi.close(3000);
          sessionStorage.removeItem(ACCESS_TOKEN_KEY);
          localStorage.setItem("isAutoLogin", false);
          this.$router.push("/login");
        })
        .finally(() => { });
    },
    closeAllBox() {
      this.$refs.groupInfo.close();
      this.$refs.userInfo.close();
    },
    playAudioTip() {
      // 播放间隔必须大于1s
      let interval = new Date().getTime() - this.lastPlayAudioTime;
      if (this.mine.isAudioTip && interval > 1000) {
        if (!this.audio) {
          this.audio = new Audio();
          this.audio.src = require(`@/assets/audio/tip.mp3`);
        }
        this.lastPlayAudioTime = new Date().getTime();
        this.audio.play();
      }
    },
    showNotification(chat, title, icon) {
      // 消息提醒
      if (window.Notification && window.electronAPI) {
        // 当窗口失去焦点，则弹出通知消息
        window.electronAPI.invoke("isFocused").then((foucus) => {
          if (!foucus) {
            this.notification && this.notification.close();
            let iconPath = icon ? icon : "logo.ico";
            this.notification = new Notification(title, {
              body: chat.lastContent,
              icon: iconPath
            });
            // 点击通知消息，激活聊天会话
            this.notification.onclick = () => {
              this.chatStore.openChat(chat);
              this.chatStore.setActiveChat(chat);
              this.$router.push("/home/chat");
              // 唤醒在后台的客户端
              window.electronAPI.sendEvent("show");
            };
          }
        });
      }
    },
    loadFriendInfo(id) {
      let friend = this.friendStore.findFriend(id);
      if (!friend) {
        friend = {
          id: id,
          showNickName: "未知用户",
          headImage: ""
        };
      }
      return friend;
    },
    loadGroupInfo(id) {
      let group = this.groupStore.findGroup(id);
      if (!group) {
        group = {
          id: id,
          showGroupName: "未知群聊",
          headImageThumb: ""
        };
      }
      return group;
    },
    showUserProfile() {
      this.$refs.userProfileCard.open();
    },
    // 操作菜单
    onLoginIpWhitelistConfirm(/* payload */) {
      // TODO: 对接保存登录 IP 白名单接口（verifyMode / ipList）
    },
    // 退出所有设备 / 本会话
    onLogoutConfirmDialog({ mode }) {
      if (mode === "device") {
        this.onExit();
        return;
      }
      if (mode === "all") {
        // TODO: 调用「退出所有设备」后端接口后再执行本地退出
        this.onExit(true);
      }
    },
    // 退出所有设备 / 本会话
    onLogoutConfirmTransfer(/* { mode } */) {
      // TODO: 先执行「确定并转接」业务（自动转接到可接待坐席），再退出所有设备 / 本会话
      this.$message.info("转接逻辑待接入接口后执行");
      this.onExit();
    },
    // 绑定二次登录验证器
    onTwoFactorBind(/* { code } */) {
      // TODO: 提交验证码绑定验证器（成功后关闭弹窗）
      // this.$refs.twoFactorLoginDialog.close();
    },
    // 获取谷歌绑定二维码
    getCode() {
      this.$http({
        url: "/user/bindGoogle",
        method: "GET"
      })
        .then((data) => {
          this.$refs.twoFactorLoginDialog.open({
            qrSrc: data.qrCodeUri
          });
        })
        .finally(() => { });
    },
    handleUserMenu(key) {
      switch (key) {
        case "account":
          this.$refs.accountInfoDialog.open();
          break;
        case "ipWhitelist":
          this.$refs.loginIpWhitelistDialog.open();
          break;
        case "loginVerify":
          this.getCode();
          // this.$refs.twoFactorLoginDialog.open();
          break;
        case "network":
          this.$refs.networkDiagnosisDialog.open();
          break;
        case "logoutDevice":
          this.$refs.logoutConfirmDialog.open("device");
          break;
        case "logoutAll":
          this.$refs.logoutConfirmDialog.open("all");
          break;
        default:
          break;
      }
      // if (key === "logout") {
      //   this.onExit();
      // }
    }
  },
  computed: {
    companyLogo() {
      return this.configStore.companyLogo || "";
    },
    companyName() {
      return this.configStore.companyName || "";
    },
    mine() {
      return this.userStore.userInfo;
    },
    unreadCount() {
      let unreadCount = 0;
      let chats = this.chatStore.chats;
      chats.forEach((chat) => {
        if (!chat.delete && !chat.isDnd) {
          unreadCount += chat.unreadCount;
        }
      });
      return unreadCount;
    },
    /** 会话未读 + 待接入转接，用于标题角标与托盘闪烁（任一项变化都会触发 watch） */
    trayAttentionCount() {
      const pending = this.pendingTransferStore.acceptBadgeCount || 0;
      return this.unreadCount + pending;
    },
    recvCount() {
      let requests = this.friendStore.requests;
      return requests.filter((req) => req.recvId == this.mine.id).length;
    }
  },
  watch: {
    trayAttentionCount: {
      handler(total) {
        const u = this.unreadCount;
        const p = this.pendingTransferStore.acceptBadgeCount || 0;
        let tip = "";
        if (u > 0 && p > 0) {
          tip = `${u}条未读 · 待接入${p}`;
        } else if (u > 0) {
          tip = `${u}条未读`;
        } else if (p > 0) {
          tip = `待接入${p}`;
        }
        this.$elm.setTitleTip(tip);
        if (window.electronAPI) {
          if (total > 0) {
            window.electronAPI.invoke("isFocused").then((foucus) => {
              if (!foucus) {
                window.electronAPI.sendEvent("startTrayBlink");
              }
            });
          } else {
            window.electronAPI.sendEvent("stopTrayBlink");
          }
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$wsApi.close();
    this.init();
    // 修改electron窗口尺寸
    window.electronAPI &&
      window.electronAPI.sendEvent("resize", {
        width: 970,
        height: 660,
        maximizable: true
      });
    window.electronAPI && window.electronAPI.sendEvent("center");
  },
  unmounted() {
    this.$eventBus.$off("exit", this.onExitFromBus);
    this.$wsApi.close();
  }
};
</script>

<style scoped lang="scss">
.home-page {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  background: var(--im-color-primary-light-9);

  .app-container {
    width: 62vw;
    height: 80vh;
    display: flex;
    min-height: 660px;
    min-width: 970px;
    position: absolute;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: var(--im-box-shadow-dark);
    transition: 0.2s;

    &.fullscreen {
      transition: 0.2s;
      width: 100vw;
      height: 100vh;
    }
  }

  .navi-bar {
    --icon-font-size: 22px;
    --width: 240px;
    min-width: var(--width);
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 15px 0;
    box-sizing: border-box;
    background: #ffffff;
    border-right: 1px solid #e5e7eb;
    background: #fff;

    .brand-card {
      display: flex;
      gap: 10px;
      padding-left: 30px;
      margin-bottom: 30px;
    }

    .brand-mark {
      width: 32px;
      height: 32px;
      margin-top: 10px;
    }

    .brand-copy {
      min-width: 0;
    }

    .brand-title {
      font-size: 24px;
      font-weight: 350;
      line-height: 32px;
      background: linear-gradient(to right, #0687ff 0%, #004ffd 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .brand-subtitle {
      margin-top: 4px;
      font-size: 10px;
      font-weight: 350;
      color: #64748b;
      letter-spacing: 0.08em;
    }

    .sidebar-nav {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .link {
      text-decoration: none;
      width: 100%;
    }

    .console-img {
      width: 20px;
      height: 20px;
    }

    .nav-button {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      gap: 10px;
      box-sizing: border-box;
      color: #4b5563;
      font-size: 14px;
      cursor: pointer;
      border: none;
      background: #ffffff;
      padding-left: 25px;
      text-align: left;

      .gzt {
        width: 18px;
        height: 18px;
      }

      &.is-active {
        color: #2563eb;
        background: #eff6ff;
        border-left: 3px solid #2563eb;
      }

      .icon-gray {
        width: 20px;
        height: 20px;
        display: block;
      }

      .icon-blue {
        width: 20px;
        width: 20px;
        display: none;
      }

      // 激活状态：隐藏灰色，显示蓝色
      &.is-active {
        color: #2563eb;
        background: #eff6ff;
        border-left: 3px solid #2563eb;

        .icon-gray {
          display: none;
        }

        .icon-blue {
          display: block;
        }
      }
    }

    .bottom-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 45px;
      width: 100%;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.7);
      font-size: var(--icon-font-size);
      border-radius: 8px;
      margin: 4px 0;
      transition: all 0.3s ease;
      position: relative;

      &:hover {
        color: white;
        background: rgba(255, 255, 255, 0.1);
        transform: scale(1.05);
      }
    }

    .logout-button {
      // height: 71px;
      // height: 95px;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      border: none;
      font-weight: 350;
      border-top: 1px solid #e2e8f0;
      background: transparent;
      color: #475569;
      font-size: 14px;
      padding: 16px 24px;
      box-sizing: border-box;
      cursor: pointer;

      .download-popover ::v-deep .el-popover {
        padding: 0 !important;
        min-width: 80px !important;
      }

      .logout-btn-box {
        width: 137px;
        margin-left: 0 !important;
        border: none !important;
        display: flex;
        align-items: center;
        justify-content: flex-start !important;
        color: #ef4444 !important;

        &:hover {
          background: transparent !important;
        }

        .logout-img {
          width: 14px;
          height: 12px;
        }
      }

      .appDown {
        color: #6b7280 !important;
      }
    }
  }

  .content-box {
    flex: 1;
    padding: 0;
    background: var(--im-background);
    text-align: center;
  }
}

.download-qrcode {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
}

.qrcode-img {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background: #fff;
}

.appDown {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.logout-img {
  width: 16px;
  height: 16px;
}
</style>
<style>
.download-popover {
  padding: 10px !important;
  min-width: 80px !important;
}
</style>
